import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <div className="bg-light py-5">
      <Helmet>
        <title>Privacy Policy | SpireNest</title>
        <link rel="canonical" href="https://spirenest.co/privacy-policy" />
        <meta name="description" content="Read SpireNest's privacy policy to understand how we collect, use, and protect your personal information." />
      </Helmet>
      <Container>
        <div className="max-w-4xl mx-auto">
          <h1 className="mb-4">Privacy Policy</h1>

          <p className="mb-4">
            This Privacy Policy outlines how SuiteMatrix ("we", "our", or "us") collects, uses, and protects your information when you use our website and mobile application.
          </p>

          <h2 className="mb-3">Information We Collect</h2>
          <p className="mb-4">
            We may collect personal information you voluntarily provide to us, such as your name and email address.
          </p>

          <h2 className="mb-3">Use of Information</h2>
          <p className="mb-2">Your information may be used to:</p>
          <ul className="mb-4">
            <li>Provide and improve our services</li>
            <li>Respond to customer service requests</li>
            <li>Send administrative or promotional communications</li>
            <li>Analyze usage trends and preferences</li>
          </ul>

          <h2 className="mb-3">Sharing of Information</h2>
          <p className="mb-4">
            We do not sell your personal data. We may share your information with third-party service providers as necessary to operate our services or when required by law.
          </p>

          <h2 className="mb-3">Security</h2>
          <p className="mb-4">
            We implement reasonable security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.
          </p>

          <h2 className="mb-3">Changes to This Policy</h2>
          <p className="mb-4">
            We may update our Privacy Policy from time to time. Updates will be posted on this page with the revised date.
          </p>

          <h2 className="mb-3">Contact Us</h2>
          <p className="mb-0">
            If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@suitematrix.co">support@suitematrix.co</a>.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default PrivacyPolicy; 